const ID = 'upload';

export default ID;
